import { useQuery } from '@tanstack/react-query';

import { UserType } from '../../../../../types/UserType';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useApiKeyList = (groupId: string, userType: UserType) => {
    return useQuery(queries.apiKeys.list(groupId, userType));
};
